// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const celesteela: PokeData = {
  "id": 797,
  "name": "celesteela",
  "height": 92,
  "weight": 9999,
  "base_experience": 257,
  "types": [
    PokeType.STEEL,
    PokeType.FLYING
  ],
  "api_moves": [
    "tackle",
    "double-edge",
    "absorb",
    "mega-drain",
    "leech-seed",
    "harden",
    "skull-bash",
    "giga-drain",
    "ingrain",
    "metal-sound",
    "iron-defense",
    "seed-bomb",
    "air-slash",
    "flash-cannon",
    "iron-head",
    "wide-guard",
    "autotomize",
    "smack-down",
    "heavy-slam"
  ],
  "moves": [
    "tackle",
    "metal-sound",
    "air-slash",
    "tailwind",
    "peck",
    "metal-burst",
    "iron-defense",
    "steel-beam",
    "metal-claw",
    "behemoth-bash",
    "gear-up",
    "brave-bird",
    "smart-strike"
  ],
  "evolution_chain": {
    "id": 418,
    "item": null,
    "species": [
      {
        "name": "celesteela",
        "order": 797,
        "types": [
          PokeType.STEEL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 149,
    "speed": 91,
    "ability_power": 160
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
